import { render, staticRenderFns } from "./coupon-send.vue?vue&type=template&id=46c684fb&scoped=true"
import script from "./coupon-send.vue?vue&type=script&lang=ts"
export * from "./coupon-send.vue?vue&type=script&lang=ts"
import style0 from "./coupon-send.vue?vue&type=style&index=0&id=46c684fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c684fb",
  null
  
)

export default component.exports